module.exports = __webpack_public_path__ + "5ad338aa2cb9441489093cfde11c7c87.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/source-sans-pro/sourcesanspro-bold.svg
// module id = 34
// module chunks = 0 1 2 3 4 5 6 7 8 9